/* SAVID header — mobile drawer toggle. Dependency-free. */
(function () {
  function boot(root) {
    var headers = (root || document).querySelectorAll('[data-savid-header]');
    Array.prototype.forEach.call(headers, function (header) {
      if (header.dataset.savidBound === '1') return;
      header.dataset.savidBound = '1';

      var burger = header.querySelector('[data-savid-burger]');
      var drawer = header.querySelector('[data-savid-drawer]');
      if (!burger || !drawer) return;

      function setOpen(open) {
        drawer.hidden = !open;
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        header.classList.toggle('is-open', open);
      }

      burger.addEventListener('click', function () {
        setOpen(drawer.hidden);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) setOpen(false);
      });

      setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
